import { useEffect, useMemo, useState } from 'react';

export const useMediaMatch = (query: string): boolean => {
  const mediaQueryList: MediaQueryList | undefined = useMemo(() => globalThis?.matchMedia?.(query), [query]);
  const [matches, setMatches] = useState<boolean>(() => mediaQueryList?.matches ?? false);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);

    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    mediaQueryList.addEventListener('change', handleChange);

    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};
